export default __webpack_public_path__ + "static/media/_south-ossetia.81774b7a.ico";